export default "__VITE_ASSET__Cda2kbjU__"